<script setup lang="ts">
import { useStatsigEventsStore } from '@apps/main/new-desktop/core/stores';

import { AppMarkdownWrapper, AppLinkButton } from '@libs/ui';

import type { HotelRoom } from '../../models';

interface HotelStayRoomProps {
  room: HotelRoom;
}

const props = defineProps<HotelStayRoomProps>();

interface HotelStayRoomEmits {
  (eventName: 'more-information'): void;
}

const emit = defineEmits<HotelStayRoomEmits>();

const statsigEventsStore = useStatsigEventsStore();

function onMoreInformationClicked(): void {
  emit('more-information');
  statsigEventsStore.logHotelDetailsCancellationPoliciesModalOpened();
}
</script>

<template>
  <div class="hotel-stay-room">
    <div class="hotel-stay-header">
      <div class="hotel-stay-heading">
        {{ props.room.name }}
      </div>
      <div class="hotel-stay-paxes">
        {{ props.room.paxString }}
      </div>
      <AppMarkdownWrapper :source="props.room.description" />
    </div>
    <AppLinkButton
      size="small"
      :text="$t('planner.more_information')"
      @click="onMoreInformationClicked"
    />
  </div>
</template>

<style scoped lang="scss">
.hotel-stay-room {
  @include font-body-m-light;
  color: var(--color-secondary-40);

  .hotel-stay-header {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-8);
    padding-bottom: var(--spacing-8);

    .hotel-stay-heading {
      color: var(--color-secondary-40);
      @include font-label-xl-bold;
    }

    .hotel-stay-paxes {
      color: var(--color-secondary-40);
      @include font-label-s-light;
    }
  }
}
</style>
